module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/logo small.svg","icons":[{"src":"/favicons/DILTSO LOGO MED.svg","sizes":"192x192","type":"image/png"},{"src":"/favicons/DILTSO LOGO LARGE(1).svg","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a35edc7d8633587fd550e0950dc7662f"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
